import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// import { categoriesScheme } from '../../../lib/validations/CategoriesValidation'
import { createCategoriesServer, getCategoriesServer, updateCategoriesServer } from '../../../apis/categoryApi'
import { categoriesScheme } from '../../../Validations/categoryValidation'

export default function AddCategory () {
  const [loading, setLoading] = useState(false)
  const [editLoader, setEditLoader] = useState(false)
  const [addCategoryInitial, setAddCategoryInitial] = useState({
    name: ''
  })
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (id) {
      editCategory(id)
    }
  }, [id])

  const editCategory = async id => {
    setEditLoader(true)
    try {
      const res = await getCategoriesServer(id)
      if (res.result) {
        setAddCategoryInitial({
          name: res.result.name
        })
      }
    } catch (error) {
      console.error('Error fetching Category:', error)
    } finally {
      setEditLoader(false)
    }
  }

  const formik = useFormik({
    initialValues: addCategoryInitial,
    enableReinitialize: true,
    validationSchema: categoriesScheme,
    onSubmit: async values => {
      try {
        setLoading(true)
        let res
        if (id) {
          values.id = id
          res = await updateCategoriesServer(id, values)
          console.log(res)
        } else {
          res = await createCategoriesServer(values)
        }
        setLoading(false)
        formik.resetForm()
        navigate('/category')
      } catch (error) {
        console.error('Error submitting form:', error)
        throw error
      }
    }
  })
  const backClick = () => {
    navigate('/category')
  }

  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            {' '}
            <i
              className='fas fa-arrow-left'
              style={{ marginRight: '30px', fontSize: '20px' }}
              onClick={backClick}
            />
            <div className='my-3 p-3 bg-body rounded shadow-sm'>
              {editLoader ? (
                <div
                  className='d-flex justify-content-center align-items-center'
                  style={{ height: '50px', padding: '7px 30px' }}
                >
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className='formMaxwidth'>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      Name <span className='text-danger'>*</span>
                    </label>
                    <input
                      className='form-control'
                      type='text'
                      name='name'
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.name && formik.touched.name && (
                      <span className='text-danger'>{formik.errors.name}</span>
                    )}
                  </div>

                  {loading ? (
                    <div
                      className='d-flex justify-content-center align-items-center'
                      style={{ height: '50px', padding: '7px 30px' }}
                    >
                      <div className='spinner-border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className='btn btn-primary' type='submit'>
                      {id ? 'Update' : 'Submit'}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
